// - - START - -
// This is an auto generated file
// - - - - - -

// Import components
import contact_en from 'components/Contact/locale/en.locale';
import contact_ja from 'components/Contact/locale/ja.locale';
import copytoclipboard_en from 'components/CopyToClipboard/locale/en.locale';
import copytoclipboard_ja from 'components/CopyToClipboard/locale/ja.locale';
import form_fileuploader_en from 'components/Form/FileUploader/locale/en.locale';
import form_fileuploader_ja from 'components/Form/FileUploader/locale/ja.locale';
import form_inputincremental_en from 'components/Form/InputIncremental/locale/en.locale';
import form_inputincremental_ja from 'components/Form/InputIncremental/locale/ja.locale';
import layout_dualpage_ricohbanner_en from 'components/Layout/DualPage/RicohBanner/locale/en.locale';
import layout_dualpage_ricohbanner_ja from 'components/Layout/DualPage/RicohBanner/locale/ja.locale';
import navigation_navigationtabs_en from 'components/Navigation/NavigationTabs/locale/en.locale';
import navigation_navigationtabs_ja from 'components/Navigation/NavigationTabs/locale/ja.locale';
import table_tablecomponents_tablepagination_en from 'components/Table/TableComponents/TablePagination/locale/en.locale';
import table_tablecomponents_tablepagination_ja from 'components/Table/TableComponents/TablePagination/locale/ja.locale';
import form_complex_en from 'examples/Form/Complex/locale/en.locale';
import form_complex_ja from 'examples/Form/Complex/locale/ja.locale';
import form_simple_en from 'examples/Form/Simple/locale/en.locale';
import form_simple_ja from 'examples/Form/Simple/locale/ja.locale';
import common_en from 'locale/common/en.locale';
import common_ja from 'locale/common/ja.locale';
import form_en from 'locale/form/en.locale';
import form_ja from 'locale/form/ja.locale';
import billing_cancelconfirm_en from 'pages/Billing/CancelConfirm/locale/en.locale';
import billing_cancelconfirm_ja from 'pages/Billing/CancelConfirm/locale/ja.locale';
import billing_details_en from 'pages/Billing/Details/locale/en.locale';
import billing_details_ja from 'pages/Billing/Details/locale/ja.locale';
import billing_mailpoints_en from 'pages/Billing/Mailpoints/locale/en.locale';
import billing_mailpoints_ja from 'pages/Billing/Mailpoints/locale/ja.locale';
import billing_planchange_en from 'pages/Billing/PlanChange/locale/en.locale';
import billing_planchange_ja from 'pages/Billing/PlanChange/locale/ja.locale';
import billing_planchange_tabnavigation_en from 'pages/Billing/PlanChange/TabNavigation/locale/en.locale';
import billing_planchange_tabnavigation_ja from 'pages/Billing/PlanChange/TabNavigation/locale/ja.locale';
import clients_client_contact_en from 'pages/Clients/Client/Contact/locale/en.locale';
import clients_client_contact_ja from 'pages/Clients/Client/Contact/locale/ja.locale';
import clients_client_sendingsettings_en from 'pages/Clients/Client/SendingSettings/locale/en.locale';
import clients_client_sendingsettings_ja from 'pages/Clients/Client/SendingSettings/locale/ja.locale';
import document_conversionsettings_bytype_en from 'pages/Document/ConversionSettings/ByType/locale/en.locale';
import document_conversionsettings_bytype_ja from 'pages/Document/ConversionSettings/ByType/locale/ja.locale';
import document_conversionsettings_root_en from 'pages/Document/ConversionSettings/Root/locale/en.locale';
import document_conversionsettings_root_ja from 'pages/Document/ConversionSettings/Root/locale/ja.locale';
import document_en from 'pages/Document/locale/en.locale';
import document_ja from 'pages/Document/locale/ja.locale';
import document_pdffilenamesettings_en from 'pages/Document/PdfFilenameSettings/locale/en.locale';
import document_pdffilenamesettings_ja from 'pages/Document/PdfFilenameSettings/locale/ja.locale';
import document_taxregistrationnumberdisplay_en from 'pages/Document/TaxRegistrationNumberDisplay/locale/en.locale';
import document_taxregistrationnumberdisplay_ja from 'pages/Document/TaxRegistrationNumberDisplay/locale/ja.locale';
import history_documentarchive_item_en from 'pages/History/DocumentArchive/Item/locale/en.locale';
import history_documentarchive_item_ja from 'pages/History/DocumentArchive/Item/locale/ja.locale';
import licensing_en from 'pages/Licensing/locale/en.locale';
import licensing_ja from 'pages/Licensing/locale/ja.locale';
import partner_integrations_ricohdirectdebit_en from 'pages/Partner/Integrations/RicohDirectDebit/locale/en.locale';
import partner_integrations_ricohdirectdebit_ja from 'pages/Partner/Integrations/RicohDirectDebit/locale/ja.locale';
import partner_integrations_ricohtradeautomation_en from 'pages/Partner/Integrations/RicohTradeAutomation/locale/en.locale';
import partner_integrations_ricohtradeautomation_ja from 'pages/Partner/Integrations/RicohTradeAutomation/locale/ja.locale';
import partner_tagssettings_en from 'pages/Partner/TagsSettings/locale/en.locale';
import partner_tagssettings_ja from 'pages/Partner/TagsSettings/locale/ja.locale';
import portal_en from 'pages/Portal/locale/en.locale';
import portal_ja from 'pages/Portal/locale/ja.locale';
import profile_changepassword_en from 'pages/Profile/ChangePassword/locale/en.locale';
import profile_changepassword_ja from 'pages/Profile/ChangePassword/locale/ja.locale';
import profile_changeusername_en from 'pages/Profile/ChangeUsername/locale/en.locale';
import profile_changeusername_ja from 'pages/Profile/ChangeUsername/locale/ja.locale';
import profile_create_companydetails_en from 'pages/Profile/Create/CompanyDetails/locale/en.locale';
import profile_create_companydetails_ja from 'pages/Profile/Create/CompanyDetails/locale/ja.locale';
import profile_create_userdetails_en from 'pages/Profile/Create/UserDetails/locale/en.locale';
import profile_create_userdetails_ja from 'pages/Profile/Create/UserDetails/locale/ja.locale';
import profile_deletionconfirm_deletionconfirmation_en from 'pages/Profile/DeletionConfirm/DeletionConfirmation/locale/en.locale';
import profile_deletionconfirm_deletionconfirmation_ja from 'pages/Profile/DeletionConfirm/DeletionConfirmation/locale/ja.locale';
import profile_deletionconfirm_deletionform_en from 'pages/Profile/DeletionConfirm/DeletionForm/locale/en.locale';
import profile_deletionconfirm_deletionform_ja from 'pages/Profile/DeletionConfirm/DeletionForm/locale/ja.locale';
import profile_emailsettings_en from 'pages/Profile/EmailSettings/locale/en.locale';
import profile_emailsettings_ja from 'pages/Profile/EmailSettings/locale/ja.locale';
import profile_notification_edit_en from 'pages/Profile/Notification/Edit/locale/en.locale';
import profile_notification_edit_ja from 'pages/Profile/Notification/Edit/locale/ja.locale';
import profile_notification_en from 'pages/Profile/Notification/locale/en.locale';
import profile_notification_ja from 'pages/Profile/Notification/locale/ja.locale';
import profile_setup_addressdetails_en from 'pages/Profile/Setup/AddressDetails/locale/en.locale';
import profile_setup_addressdetails_ja from 'pages/Profile/Setup/AddressDetails/locale/ja.locale';
import profile_setup_businesscontact_en from 'pages/Profile/Setup/BusinessContact/locale/en.locale';
import profile_setup_businesscontact_ja from 'pages/Profile/Setup/BusinessContact/locale/ja.locale';
import profile_setup_preview_en from 'pages/Profile/Setup/Preview/locale/en.locale';
import profile_setup_preview_ja from 'pages/Profile/Setup/Preview/locale/ja.locale';
import staff_customtemplatesearch_en from 'pages/Staff/CustomTemplateSearch/locale/en.locale';
import staff_customtemplatesearch_ja from 'pages/Staff/CustomTemplateSearch/locale/ja.locale';
import team_activeteammembers_en from 'pages/Team/ActiveTeamMembers/locale/en.locale';
import team_activeteammembers_ja from 'pages/Team/ActiveTeamMembers/locale/ja.locale';
import team_changeowner_en from 'pages/Team/ChangeOwner/locale/en.locale';
import team_changeowner_ja from 'pages/Team/ChangeOwner/locale/ja.locale';
import team_groupsandroles_create_en from 'pages/Team/GroupsAndRoles/Create/locale/en.locale';
import team_groupsandroles_create_ja from 'pages/Team/GroupsAndRoles/Create/locale/ja.locale';
import team_groupsandroles_edit_en from 'pages/Team/GroupsAndRoles/Edit/locale/en.locale';
import team_groupsandroles_edit_ja from 'pages/Team/GroupsAndRoles/Edit/locale/ja.locale';
import team_groupsandroles_list_en from 'pages/Team/GroupsAndRoles/List/locale/en.locale';
import team_groupsandroles_list_ja from 'pages/Team/GroupsAndRoles/List/locale/ja.locale';
import team_groupsandroles_teamview_en from 'pages/Team/GroupsAndRoles/TeamView/locale/en.locale';
import team_groupsandroles_teamview_ja from 'pages/Team/GroupsAndRoles/TeamView/locale/ja.locale';
import team_member_edit_en from 'pages/Team/Member/Edit/locale/en.locale';
import team_member_edit_ja from 'pages/Team/Member/Edit/locale/ja.locale';
import team_member_employeerights_en from 'pages/Team/Member/EmployeeRights/locale/en.locale';
import team_member_employeerights_ja from 'pages/Team/Member/EmployeeRights/locale/ja.locale';
import team_member_groups_en from 'pages/Team/Member/Groups/locale/en.locale';
import team_member_groups_ja from 'pages/Team/Member/Groups/locale/ja.locale';
import team_member_notification_en from 'pages/Team/Member/Notification/locale/en.locale';
import team_member_notification_ja from 'pages/Team/Member/Notification/locale/ja.locale';
import team_member_overview_en from 'pages/Team/Member/Overview/locale/en.locale';
import team_member_overview_ja from 'pages/Team/Member/Overview/locale/ja.locale';
import team_member_revoke_en from 'pages/Team/Member/Revoke/locale/en.locale';
import team_member_revoke_ja from 'pages/Team/Member/Revoke/locale/ja.locale';
import team_revoked_en from 'pages/Team/Revoked/locale/en.locale';
import team_revoked_ja from 'pages/Team/Revoked/locale/ja.locale';

const resources = {
    en: {
        Contact: contact_en,
        CopyToClipboard: copytoclipboard_en,
        'Form.FileUploader': form_fileuploader_en,
        'Form.InputIncremental': form_inputincremental_en,
        'Layout.DualPage.RicohBanner': layout_dualpage_ricohbanner_en,
        'Navigation.NavigationTabs': navigation_navigationtabs_en,
        'Table.TableComponents.TablePagination':
            table_tablecomponents_tablepagination_en,
        'Form.Complex': form_complex_en,
        'Form.Simple': form_simple_en,
        common: common_en,
        form: form_en,
        'Billing.CancelConfirm': billing_cancelconfirm_en,
        'Billing.Details': billing_details_en,
        'Billing.Mailpoints': billing_mailpoints_en,
        'Billing.PlanChange.TabNavigation': billing_planchange_tabnavigation_en,
        'Billing.PlanChange': billing_planchange_en,
        'Clients.Client.Contact': clients_client_contact_en,
        'Clients.Client.SendingSettings': clients_client_sendingsettings_en,
        'Document.ConversionSettings.ByType':
            document_conversionsettings_bytype_en,
        'Document.ConversionSettings.Root': document_conversionsettings_root_en,
        'Document.PdfFilenameSettings': document_pdffilenamesettings_en,
        'Document.TaxRegistrationNumberDisplay':
            document_taxregistrationnumberdisplay_en,
        Document: document_en,
        'History.DocumentArchive.Item': history_documentarchive_item_en,
        Licensing: licensing_en,
        'Partner.Integrations.RicohDirectDebit':
            partner_integrations_ricohdirectdebit_en,
        'Partner.Integrations.RicohTradeAutomation':
            partner_integrations_ricohtradeautomation_en,
        'Partner.TagsSettings': partner_tagssettings_en,
        Portal: portal_en,
        'Profile.ChangePassword': profile_changepassword_en,
        'Profile.ChangeUsername': profile_changeusername_en,
        'Profile.Create.CompanyDetails': profile_create_companydetails_en,
        'Profile.Create.UserDetails': profile_create_userdetails_en,
        'Profile.DeletionConfirm.DeletionConfirmation':
            profile_deletionconfirm_deletionconfirmation_en,
        'Profile.DeletionConfirm.DeletionForm':
            profile_deletionconfirm_deletionform_en,
        'Profile.EmailSettings': profile_emailsettings_en,
        'Profile.Notification.Edit': profile_notification_edit_en,
        'Profile.Notification': profile_notification_en,
        'Profile.Setup.AddressDetails': profile_setup_addressdetails_en,
        'Profile.Setup.BusinessContact': profile_setup_businesscontact_en,
        'Profile.Setup.Preview': profile_setup_preview_en,
        'Staff.CustomTemplateSearch': staff_customtemplatesearch_en,
        'Team.ActiveTeamMembers': team_activeteammembers_en,
        'Team.ChangeOwner': team_changeowner_en,
        'Team.GroupsAndRoles.Create': team_groupsandroles_create_en,
        'Team.GroupsAndRoles.Edit': team_groupsandroles_edit_en,
        'Team.GroupsAndRoles.List': team_groupsandroles_list_en,
        'Team.GroupsAndRoles.TeamView': team_groupsandroles_teamview_en,
        'Team.Member.Edit': team_member_edit_en,
        'Team.Member.EmployeeRights': team_member_employeerights_en,
        'Team.Member.Groups': team_member_groups_en,
        'Team.Member.Notification': team_member_notification_en,
        'Team.Member.Overview': team_member_overview_en,
        'Team.Member.Revoke': team_member_revoke_en,
        'Team.Revoked': team_revoked_en,
    },
    ja: {
        Contact: contact_ja,
        CopyToClipboard: copytoclipboard_ja,
        'Form.FileUploader': form_fileuploader_ja,
        'Form.InputIncremental': form_inputincremental_ja,
        'Layout.DualPage.RicohBanner': layout_dualpage_ricohbanner_ja,
        'Navigation.NavigationTabs': navigation_navigationtabs_ja,
        'Table.TableComponents.TablePagination':
            table_tablecomponents_tablepagination_ja,
        'Form.Complex': form_complex_ja,
        'Form.Simple': form_simple_ja,
        common: common_ja,
        form: form_ja,
        'Billing.CancelConfirm': billing_cancelconfirm_ja,
        'Billing.Details': billing_details_ja,
        'Billing.Mailpoints': billing_mailpoints_ja,
        'Billing.PlanChange.TabNavigation': billing_planchange_tabnavigation_ja,
        'Billing.PlanChange': billing_planchange_ja,
        'Clients.Client.Contact': clients_client_contact_ja,
        'Clients.Client.SendingSettings': clients_client_sendingsettings_ja,
        'Document.ConversionSettings.ByType':
            document_conversionsettings_bytype_ja,
        'Document.ConversionSettings.Root': document_conversionsettings_root_ja,
        'Document.PdfFilenameSettings': document_pdffilenamesettings_ja,
        'Document.TaxRegistrationNumberDisplay':
            document_taxregistrationnumberdisplay_ja,
        Document: document_ja,
        'History.DocumentArchive.Item': history_documentarchive_item_ja,
        Licensing: licensing_ja,
        'Partner.Integrations.RicohDirectDebit':
            partner_integrations_ricohdirectdebit_ja,
        'Partner.Integrations.RicohTradeAutomation':
            partner_integrations_ricohtradeautomation_ja,
        'Partner.TagsSettings': partner_tagssettings_ja,
        Portal: portal_ja,
        'Profile.ChangePassword': profile_changepassword_ja,
        'Profile.ChangeUsername': profile_changeusername_ja,
        'Profile.Create.CompanyDetails': profile_create_companydetails_ja,
        'Profile.Create.UserDetails': profile_create_userdetails_ja,
        'Profile.DeletionConfirm.DeletionConfirmation':
            profile_deletionconfirm_deletionconfirmation_ja,
        'Profile.DeletionConfirm.DeletionForm':
            profile_deletionconfirm_deletionform_ja,
        'Profile.EmailSettings': profile_emailsettings_ja,
        'Profile.Notification.Edit': profile_notification_edit_ja,
        'Profile.Notification': profile_notification_ja,
        'Profile.Setup.AddressDetails': profile_setup_addressdetails_ja,
        'Profile.Setup.BusinessContact': profile_setup_businesscontact_ja,
        'Profile.Setup.Preview': profile_setup_preview_ja,
        'Staff.CustomTemplateSearch': staff_customtemplatesearch_ja,
        'Team.ActiveTeamMembers': team_activeteammembers_ja,
        'Team.ChangeOwner': team_changeowner_ja,
        'Team.GroupsAndRoles.Create': team_groupsandroles_create_ja,
        'Team.GroupsAndRoles.Edit': team_groupsandroles_edit_ja,
        'Team.GroupsAndRoles.List': team_groupsandroles_list_ja,
        'Team.GroupsAndRoles.TeamView': team_groupsandroles_teamview_ja,
        'Team.Member.Edit': team_member_edit_ja,
        'Team.Member.EmployeeRights': team_member_employeerights_ja,
        'Team.Member.Groups': team_member_groups_ja,
        'Team.Member.Notification': team_member_notification_ja,
        'Team.Member.Overview': team_member_overview_ja,
        'Team.Member.Revoke': team_member_revoke_ja,
        'Team.Revoked': team_revoked_ja,
    },
};
export default resources;
